// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__25fpM","loader":"Loader_loader__2hZcM","spinner":"Loader_spinner__1BGHY","spin":"Loader_spin__1X-nh"};